export default "__VITE_ASSET__CklCP5g3__"